module.exports = __webpack_public_path__ + "static/media/cellfinate_social_4.70bfb61f.jpg";